import { Components, Theme } from '@mui/material/styles';

export const MuiCssBaseline: Components<Theme>['MuiCssBaseline'] = {
  styleOverrides: (theme) => ({
    body: {
      '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
        width: '4px',
        height: '4px',
        backgroundColor: theme.palette.background.paper,
      },
      '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
        borderRadius: '8px',
        backgroundColor: theme.palette.primary.light,
        minHeight: '24px',
        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
        },
      },
      '&::-webkit-scrollbar-track, & *::-webkit-scrollbar-track': {
        backgroundColor: theme.palette.background.default,
      },
      '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
        backgroundColor: theme.palette.background.paper,
      },
    },
  }),
};
